import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//工作量相关API

const courseAdjust = {
    courseAdjust: {
        queryList: config => createAPI('/courseAdjust/queryList', 'post', config),
        initOption: config => createAPI('/courseAdjust/initOption', 'post', config),
        teacherOption: config => createAPI('/courseAdjust/teacherOption', 'post', config),
        majorOption: config => createAPI('/courseAdjust/majorOption', 'post', config),
        classOption: config => createAPI('/courseAdjust/classOption', 'post', config),
        courseOption: config => createAPI('/courseAdjust/courseOption', 'post', config),
        skzcOption: config => createAPI('/courseAdjust/skzcOption', 'post', config),
        weekOption: config => createAPI('/courseAdjust/weekOption', 'post', config),
        jcOption: config => createAPI('/courseAdjust/jcOption', 'post', config),
        adjustReasonOption: config => createAPI('/courseAdjust/adjustReasonOption', 'post', config),
        siteOption: config => createAPI('/courseAdjust/siteOption', 'post', config),
        saveAdjust: config => createAPI('/courseAdjust/saveAdjust', 'post', config),
        checkApplyUsed: config => createAPI('/courseAdjust/checkApplyUsed', 'post', config),
        auditReject: config => createAPI('/courseAdjust/auditReject', 'post', config),
        queryAuditFlow: config => createAPI('/courseAdjust/queryAuditFlow', 'post', config),
        
        uploadMultiFile: config => createAPI('/courseAdjust/uploadMultiFile', 'post', config),
        attachmentList: config => createAPI('/courseAdjust/attachmentList', 'post', config),
        delFile: config => createAPI('/courseAdjust/delFile', 'post', config),
        updateAuditState: config => createAPI('/courseAdjust/updateAuditState', 'post', config),
        yjhskzcOption: config => createAPI('/courseAdjust/yjhskzcOption', 'post', config),
        yjhxqOption: config => createAPI('/courseAdjust/yjhxqOption', 'post', config),
        yjhsjxlOption: config => createAPI('/courseAdjust/yjhsjxlOption', 'post', config),
        teaAndSiteOption: config => createAPI('/courseAdjust/teaAndSiteOption', 'post', config),
        tzhskzcOption: config => createAPI('/courseAdjust/tzhskzcOption', 'post', config),
        tzhxqOption: config => createAPI('/courseAdjust/tzhxqOption', 'post', config),
        tzhsjxlOption: config => createAPI('/courseAdjust/tzhsjxlOption', 'post', config),
        checkEnableSite: config => createAPI('/courseAdjust/checkEnableSite', 'post', config),
        checkUnauditAdjust: config => createAPI('/courseAdjust/checkUnauditAdjust', 'post', config),

        queryList_monitor: config => createAPI('/courseAdjust/queryList_monitor', 'post', config),
        monitorConfirm: config => createAPI('/courseAdjust/monitorConfirm', 'post', config),
        queryclass: config => createAPI('/courseAdjust/queryclass', 'post', config),
        exportAdjustInfo: config => createAPI('/courseAdjust/exportAdjustInfo', 'post', config),
        queryBtkxx: config => createAPI('/courseAdjust/queryBtkxx', 'post', config),
    },
};


export default courseAdjust;



// WEBPACK FOOTER //
// ./src/api/modules/courseAdjust.js